import { render, staticRenderFns } from "./dataCatalogOverview.vue?vue&type=template&id=c77ae6fe&scoped=true"
import script from "./dataCatalogOverview.vue?vue&type=script&lang=js"
export * from "./dataCatalogOverview.vue?vue&type=script&lang=js"
import style0 from "./dataCatalogOverview.vue?vue&type=style&index=0&id=c77ae6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77ae6fe",
  null
  
)

export default component.exports